const ServiceHeaderAPI = [
  {
    id: 1,
    logo: "fa-solid fa-calendar-check",
    title: "Online Appointment Booking",
    info: "Users can conveniently book appointments with their preferred doctors through our platform. With just a few clicks, they can schedule their visit without the hassle of waiting in long queues or making multiple phone calls.",
  },
  {
    id: 2,
    logo: "fa-solid fa-user-doctor",
    title: "Doctor Selection and Reviews",
    info: "Patients can choose their doctors based on detailed profiles and reviews from other users. This feature helps them make informed decisions about their healthcare providers, ensuring they receive quality care that meets their needs.",
  },
  {
    id: 3,
    logo: "fa-solid fa-clock",
    title: "Doctor Scheduling for Next 7 Days",
    info: "Doctors can manage their availability for the upcoming week, making it easier for patients to find a suitable time for their appointments. This scheduling feature enhances efficiency and reduces wait times for both doctors and patients.",
  },
];

export default ServiceHeaderAPI;
